import React, { VFC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Card, CardContainer, getSpacing, Text, TextView } from '@rahtab/ui';
import { Screen, StackScreenProps } from '@rahtab/stack-navigator';
import { RootStackType } from '../../Router';
import { useStopStock } from 'hooks/InventoryHooks/useStopStock';
import { fixDateTime, withSeparator, withToman } from '@rahtab/system/lib/tools/string';
import { useLoad } from 'hooks/InventoryHooks/useLoad';
import moment from 'moment-jalaali';

const StopStock: VFC<StopStockProps> = ({ route }) => {
  const { assignFinalCode } = route.params;
  const { loading, stopStock, data } = useStopStock(route.params);
  const load = useLoad({ assignFinalCode });
  return (
    <Screen
      title="ثبت توقف عرضه بار"
      transparentLoading={loading}
      data={data}
      renderMain={(info) => {
        const { saleAmount, stockAmount, stockDate, stockPrice, salePercent } = info;
        return (
          <Card style={styles.card}>
            <CardContainer>
              <TextView title="تاریخ ثبت عرضه" value={moment(stockDate).format('jYYYY/jMM/jDD | HH:mm')} />
              {/* <View style={styles.rowView}> */}
              <TextView
                // style={styles.biggerTextView}
                title="قیمت مصرف کننده"
                value={withToman(stockPrice)}
              />
              {/* <TextView style={styles.smallerTextView} title="درصد رشد" valueColor="secondary" isSpaceBetween /> */}
              {/* </View> */}
              <TextView title="مقدار عرضه بار" value={`${withSeparator(stockAmount)} ${load.data?.measureName}`} />
              <View style={styles.rowView}>
                <TextView
                  title="مقدار فروش"
                  value={`${withSeparator(saleAmount)} ${load.data?.measureName}`}
                  style={styles.biggerTextView}
                />
                <TextView
                  value={`٪${salePercent}`}
                  textContainerStyle={{ justifyContent: 'center' }}
                  valueColor="secondary"
                  style={styles.smallerTextView}
                />
              </View>
              <Button text="توقف عرضه بار" color="secondary" onPress={stopStock} />
            </CardContainer>
          </Card>
        );
      }}
    />
  );
};

export default StopStock;

const styles = StyleSheet.create({
  card: {
    margin: getSpacing(),
  },
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  biggerTextView: {
    flex: 3,
    marginRight: getSpacing(),
  },
  smallerTextView: {
    width: 50,
  },
});

type StopStockProps = StackScreenProps<RootStackType, 'StopStock'>;
